import { NavLink } from "react-router-dom";

export default function SettingsNav() {
  return (
    <aside className="settings-nav" aria-label="设置导航">
      <h1>设置</h1>
      <NavLink to="/settings/profile">编辑个人资料</NavLink>
      <NavLink to="/settings/security">账号与安全</NavLink>
      <NavLink to="/settings/provider">服务者申请</NavLink>
    </aside>
  );
}
